import BaseHttp from '@/plugins/baseHttp';

const getUsers = () => {
  return BaseHttp.get('/backoffice/users/search',);
};

const findUser = (id,) => {
  return BaseHttp.get(`/backoffice/users/${id}`,);
};

const createUser = (payload,) => {
  return BaseHttp.post('/backoffice/users', payload,);
};

const updateUser = (id, payload,) => {
  return BaseHttp.patch(`/backoffice/users/${id}`, payload,);
};

const activeUser = (payload,) => {
  const { id, } = payload;
  return BaseHttp.post(`/backoffice/users/${id}/active`,);
};

const inactiveUser = (payload,) => {
  const { id, } = payload;
  return BaseHttp.post(`/backoffice/users/${id}/inactive`,);
};

const getBusinessTypes = () => {
  return BaseHttp.get('/backoffice/business-types',);
};

const getRolesPositions = () => {
  return BaseHttp.get('/backoffice/roles/positions',).then(({data,},) => ({positions: data.data,}),);
};

const getRolesWorkGroups = () => {
  return BaseHttp.get('/backoffice/roles/work-groups',).then(({data,},) => ({workgroups: data.data,}),);
};

const getRoles = () => {
  return BaseHttp.get('/backoffice/roles',).then(({data,},) => ({roles: data,}),);
};

const getPermissions = () => {
  return BaseHttp.get('/backoffice/permissions',).then(({data,},) => ({permissions: data.data,}),);
};

const getStates = () => {
  const path = '/franchises/states';
  return BaseHttp.get(path,).then(({data,},) => ({states: data,}),);
};

const getCities = (state, limit,) => {
  const path = `/franchises?franchise_address.state=${state}&fields=franchise_address.city&limit=${limit}`;
  return BaseHttp.get(path,).then(({data,},) => ({cities: data,}),);
};

const getServiceTypes = () => {
  return BaseHttp.get('/backoffice/roles/service-types',).then(({data,},) => ({ serviceTypes: data, }),);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};


export {
  getUsers,
  findUser,
  createUser,
  updateUser,
  handleError,
  activeUser,
  inactiveUser,
  getBusinessTypes,
  getRolesPositions,
  getRolesWorkGroups,
  getRoles,
  getStates,
  getCities,
  getPermissions,
  getServiceTypes,
};
